import { render, staticRenderFns } from "./mySecondLevel.vue?vue&type=template&id=ed50b40e&scoped=true"
import script from "./mySecondLevel.vue?vue&type=script&lang=js"
export * from "./mySecondLevel.vue?vue&type=script&lang=js"
import style0 from "./mySecondLevel.vue?vue&type=style&index=0&id=ed50b40e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed50b40e",
  null
  
)

export default component.exports